import { FC } from "react";
import { styled } from "@mui/material/styles";
import MuiCheckbox, { CheckboxProps } from "@mui/material/Checkbox";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import CheckBoxOutlineBlankOutlinedIcon from "@mui/icons-material/CheckBoxOutlineBlankOutlined";

const StyledCheckBox = styled(MuiCheckbox)(({ theme }) => ({
  "&.MuiCheckbox-root": {
    "& .MuiSvgIcon-root": {
      color: theme.colors.shades[500],
      height: 20,
      width: 20,
    },

    "&.Mui-checked, &.Mui-focusVisible": {
      "& .MuiSvgIcon-root": {
        color: theme.colors.sapphire,
      },
    },

    "&.Mui-disabled": {
      "& .MuiSvgIcon-root": {
        color: theme.colors.shades[300],
      },
    },
  },
}));

const Checkbox: FC<CheckboxProps> = (props) => {
  return (
    <StyledCheckBox
      icon={<CheckBoxOutlineBlankOutlinedIcon />}
      checkedIcon={<CheckBoxOutlinedIcon />}
      disableFocusRipple
      disableRipple
      {...props}
    />
  );
};

export default Checkbox;
